import axios from "./axios";

export const fetchSampleQuestionSet = async (email, userGptKey, userType, category, subCategory, docId) => {
  try {
    const response = await axios.get("/get_sample_question_set", {
      params: {
        category: category,
        subCategory: subCategory,
        docId: docId,
        noOfShqa: 1,
        noOfMcq: 1,
        noOfFib: 1,
        noOfTruefalse: 1,
        noOfInterpritive: 1,
        noOfDescriptive: 1,
        noOfSbq: 1,
        email: email,
        userType: userType,
        userGptKey: userGptKey
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};
